import React from 'react';
import { Text, Group, Card, Divider, Stack } from '@mantine/core';
import { IDataCutsPreviewProps } from './SurveyJobTypes';
import { getFieldData } from '../utils';

export const DataCutsPreview = ({ item }: IDataCutsPreviewProps) => {

  if (!item.dataCuts.length) return (
    <Card style={{ padding: 'var(--mantine-spacing-lg)', width: 'fit-content', border: 'solid', borderColor: 'var(--mantine-color-red-7)', boxShadow: 'var(--mantine-shadow-xs)' }}>
      <Text size="lg">
        No data cuts selected
      </Text>
    </Card>
  )

  const displayDataCut = item.dataCuts[0];
  const numAdditionalDataCuts = item.dataCuts.length - 1;
  const surveyJobTitle = getFieldData('job_title_default', displayDataCut.data, displayDataCut.terms);
  const surveyJobCode = getFieldData('job_code_default', displayDataCut.data, displayDataCut.terms);
  const dataCutName = getFieldData('job_scope_default', displayDataCut.data, displayDataCut.terms);

  return (
    <Card radius='lg' style={{ padding: 'var(--mantine-spacing-lg)', width: 'fit-content', border: 'solid', borderColor: 'var(--mantine-color-green-7)', boxShadow: 'var(--mantine-shadow-xs)' }}>
      <Stack gap="xs">
        <Group justify='space-between'>
          <Text size="lg">
            {surveyJobTitle}
          </Text>
          <Divider orientation='vertical' size='sm' />
          <Text size="lg">
            {surveyJobCode}
          </Text>
          <Divider orientation='vertical' size='sm' />
          <Text size='lg'>
            {dataCutName}
          </Text>
        </Group>
        {numAdditionalDataCuts > 0 && (
          <Text size="lg"  fw={700}>
            +{numAdditionalDataCuts} more
          </Text>
        )}
      </Stack>
    </Card>
  )

}